import { Accordion } from "semantic-ui-react";

import { useCollectionData } from "astrid-firestore/src/hooks/index";

import useCostsQuery from "../../../../costs/hooks/useCostsQuery";
import LoadingContext from "../../../../ui/components/LoadingContext/LoadingContext";

import OrderDetails from "../../OrderDetails/OrderDetails";

import OrderTitle from "./OrderTitle";

export default function Order({ active, order, readOnly, ...props }) {
	const costsQuery = useCostsQuery({ orderId: order.id });

	const [costs = [], loading, error] = useCollectionData(order && costsQuery);

	return (
		<LoadingContext data={costs} loading={loading} error={error}>
			<OrderTitle active={active} order={order} {...props} />

			{active && (
				<Accordion.Content active>
					<OrderDetails order={order} costs={costs} readOnly={readOnly} />
				</Accordion.Content>
			)}
		</LoadingContext>
	);
}
